import { BannerTrackingConfig, useBannerTracking } from "@/hook/useBannerTracking"
import React, { ReactNode } from "react"

interface BannerWithTrackingProps {
  children: ReactNode
  trackingConfig?: BannerTrackingConfig
  bannerUrl?: string
  bannerId?: string
  className?: string
  onClick?: () => void
}

export const BannerWithTracking: React.FC<BannerWithTrackingProps> = ({
  children,
  trackingConfig,
  bannerUrl,
  bannerId,
  className = "",
  onClick,
}) => {
  const { trackClick, getImpressionTrackingData } = useBannerTracking()

  const handleClick = () => {
    if (onClick) {
      onClick()
    }
    trackClick(trackingConfig, bannerUrl)
  }

  const trackingData = getImpressionTrackingData(trackingConfig)

  return (
    <div className={className}>
      {/* Clickable banner area */}
      <div onClick={handleClick} style={{ cursor: bannerUrl ? 'pointer' : 'default' }}>
        {children}
      </div>

      {/* Impression tracking elements */}
      {trackingData && (
        <>
          {trackingData.impressionHtml && trackingData.impressionHtml.length > 0 && (
            <div style={{ display: "none" }}>
              {trackingData.impressionHtml.map((htmlBlock, index) => (
                <div key={index} dangerouslySetInnerHTML={{ __html: htmlBlock }} />
              ))}
            </div>
          )}

          {trackingData.vendorScriptSrc && (
            <script
              src={trackingData.vendorScriptSrc}
              async
              data-banner-id={bannerId}
            />
          )}

          {trackingData.vendorNoscriptHtml && (
            <noscript dangerouslySetInnerHTML={{ __html: trackingData.vendorNoscriptHtml }} />
          )}
        </>
      )}
    </div>
  )
}

export default BannerWithTracking
